package com.example.readingnotes.domain.usecase

import com.example.readingnotes.domain.repository.AuthRepository
import com.example.readingnotes.util.Result

class VerifyTotpUseCase(
    private val authRepository: AuthRepository,
) {
    suspend operator fun invoke(code: String): Result<Boolean> {
        if (code.isBlank()) {
            return Result.failure(IllegalArgumentException("認証コードを入力してください"))
        }
        if (!code.matches(Regex("^\\d{6}$"))) {
            return Result.failure(IllegalArgumentException("認証コードは6桁の数字で入力してください"))
        }
        return authRepository.verifyTotp(code)
    }
}
